import { optionalContextFactory } from '../../../hooks/optional-context-factory';

export type ModalAppConfigState = {
  topOffset?: number;
  /**
   * Opt-in, off by default. When true, modals rendered into `<body>` are pinned to the viewport (`position: fixed`)
   * and focusing them on open does not scroll the page, so they open on screen when the window is scrolled
   * (notably on iOS Safari). Modals with a custom mount target are unaffected.
   */
  pinToViewport?: boolean;
};

const [context, useModalAppConfigContextMethod] = optionalContextFactory<ModalAppConfigState>(
  {} as ModalAppConfigState
);

export type ModalAppConfigProviderProps = React.PropsWithChildren<ModalAppConfigState>;

export const ModalAppConfigProvider = ({ children, ...props }: ModalAppConfigProviderProps) => {
  return <context.Provider value={props}>{children}</context.Provider>;
};

export { useModalAppConfigContextMethod as useModalAppConfigContext };
